var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"100%","elevation":"0"}},[_c('v-card-text',{staticClass:"d-flex justify-center align-center"},[_c('div',{staticClass:"py-6 text-center black--text"},[_c('h1',[_vm._v("CAMA VACÍA!")]),_c('div',{staticClass:"pa-4 d-block"},[_vm._v("No tienes permiso para asignar camas")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }